export const FETCH_PROMO_CODES_REQUEST = 'FETCH_PROMO_CODES_REQUEST';
export const FETCH_PROMO_CODES_SUCCESS = 'FETCH_PROMO_CODES_SUCCESS';
export const FETCH_PROMO_CODES_FAILED = 'FETCH_PROMO_CODES_FAILED';

export const FETCH_PROMO_CODE_BY_ID_REQUEST = 'FETCH_PROMO_CODE_BY_ID_REQUEST';
export const FETCH_PROMO_CODE_BY_ID_SUCCESS = 'FETCH_PROMO_CODE_BY_ID_SUCCESS';
export const FETCH_PROMO_CODE_BY_ID_FAILED = 'FETCH_PROMO_CODE_BY_ID_FAILED';

export const CREATE_PROMO_CODE_REQUEST = 'CREATE_PROMO_CODE_REQUEST';
export const CREATE_PROMO_CODE_SUCCESS = 'CREATE_PROMO_CODE_SUCCESS';
export const CREATE_PROMO_CODE_FAILED = 'CREATE_PROMO_CODE_FAILED';

export const RESET_PROMO_CODE = 'RESET_PROMO_CODE';

export const DELETE_PROMO_CODE_REQUEST = 'DELETE_PROMO_CODE_REQUEST';
export const DELETE_PROMO_CODE_SUCCESS = 'DELETE_PROMO_CODE_SUCCESS';
export const DELETE_PROMO_CODE_FAILED = 'DELETE_PROMO_CODE_FAILED';

export const UPDATE_PROMO_CODE_REQUEST = 'UPDATE_PROMO_CODE_REQUEST';
export const UPDATE_PROMO_CODE_SUCCESS = 'UPDATE_PROMO_CODE_SUCCESS';
export const UPDATE_PROMO_CODE_FAILED = 'UPDATE_PROMO_CODE_FAILED';
export const UPDATE_PROMO_CODE_RESET = 'UPDATE_PROMO_CODE_RESET';
